export default __webpack_public_path__ + "static/course-logo-cag-e78ea285f887429d1a0fefbfefab7467.jpg";